import React, { useContext } from 'react';
import { DarkModeContext } from '../DarkModeContext';


const DarkModeToggle = () => {
  const { darkMode, toggleDarkMode } = useContext(DarkModeContext);

  return (
    <div className={`dark-mode-toggle ${darkMode ? 'dark' : 'light'}`}>
      <button onClick={toggleDarkMode} aria-label={darkMode ? "Activate light mode" : "Activate dark mode"}>
        {darkMode ? '🌞' : '🌙'}
      </button>
      
    </div>
  );
};

export default DarkModeToggle;